import { tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import Content from '../Content'

export default function ForumThread({
  event,
  className,
  clamp
}: {
  event: Event
  className?: string
  clamp?: boolean
}) {
  const title = useMemo(() => event.tags.find(tagNameEquals('title'))?.[1], [event])

  return (
    <div className={cn('space-y-2', className)}>
      {title && <div className="text-xl font-semibold line-clamp-2">{title}</div>}
      <Content event={event} clamp={clamp} />
    </div>
  )
}
